import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const RevolutionizeMobileConnectivity = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <section
        style={{ backgroundImage: `url('../images/mobile-connectivity.jpg')`, backgroundSize: "100% 60vh" }}
        className="hero--container relative flex flex-col justify-center w-full h-[60vh] bg-no-repeat bg-fixed md:bg-origin-border pt-[65px]">
        <p className="text-white p-1.5 rounded-md text-xs font-bold text-center mb-10 bg-blue-500 mx-auto">
          5G, Mobile Connectivity
        </p>
        <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
          How 5G Will Revolutionize Mobile Connectivity
        </h1>

        <div className="flex justify-center items-center gap-4 mt-10">
          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faClock} className="w-4" />
            <p className="blog-publish-date">28/01/2025</p>
          </div>

          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faComment} className="w-4" />
            <p className="blog-publish-date">25 Comments</p>
          </div>

          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faBookmark} />
            <p className="blog-publish-date">5000 Views</p>
          </div>
        </div>
      </section>

      <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
        <div className="mx-auto max-w-screen-md">
          <p className="pb-4 text-justify leading-7">
            The advent of 5G technology marks a transformative era in mobile connectivity. As the fifth generation of wireless technology, 5G promises lightning-fast speeds, ultra-low latency, and massive device connectivity, redefining how we interact with the digital world.
          </p>

          <img src="../images/mobile-connectivity.jpg" alt="5G Connectivity" className="mx-auto mt-3 mb-6 w-full" />

          <p className="pb-4 text-justify leading-7">
            One of the most significant breakthroughs of 5G is its speed. With peak download speeds reaching up to 10 Gbps, 5G is nearly 100 times faster than its predecessor, 4G. This rapid data transfer capability enables seamless streaming of 4K and even 8K videos, enhancing the user experience for entertainment and virtual reality applications.
          </p>

          <p className="pb-4 text-justify leading-7">
            Beyond speed, 5G’s ultra-low latency—as low as 1 millisecond—is a game changer for real-time applications. This latency reduction is critical for technologies like autonomous vehicles, where split-second decisions can save lives. Similarly, it paves the way for immersive experiences in augmented reality (AR) and virtual reality (VR), allowing users to interact in real time without noticeable lag.
          </p>

          <p className="pb-4 text-justify leading-7">
            5G’s capacity to connect millions of devices simultaneously is another remarkable feature. This capability supports the growth of the Internet of Things (IoT), enabling smart cities, industrial automation, and advanced healthcare systems. From smart thermostats and wearable devices to interconnected factories, 5G creates a cohesive network for data-driven decision-making.
          </p>

          <p className="pb-4 text-justify leading-7">
            Industries are set to benefit immensely from 5G technology. In healthcare, for instance, 5G can enable remote surgeries and real-time patient monitoring, bridging the gap between doctors and patients regardless of location. In manufacturing, 5G-powered robotics and automation streamline production processes, increasing efficiency and reducing costs.
          </p>

          <p className="pb-4 text-justify leading-7">
            Education and remote work are also poised for transformation. 5G ensures high-quality video conferencing, interactive virtual classrooms, and cloud-based collaboration tools, making remote interactions as effective as in-person experiences. This connectivity is crucial in bridging the digital divide and providing equal opportunities worldwide.
          </p>

          <p className="pb-4 text-justify leading-7">
            Despite its promises, the rollout of 5G comes with challenges. Infrastructure upgrades, spectrum allocation, and cybersecurity concerns are hurdles that need addressing. Additionally, the high cost of deployment may limit access in developing regions, potentially widening the digital gap.
          </p>

          <p className="pb-4 text-justify leading-7">
            As 5G continues to expand globally, its impact on society will be profound. By fostering innovation and connectivity, 5G is not just a technological upgrade but a foundation for future advancements in AI, IoT, and beyond.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <div className="max-w-screen-md mx-auto rounded-md flex justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">5G</p>
            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Connectivity</p>
            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Technology</p>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center bg-[#42599E] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} /> share
              </a>
            </div>
            <div className="flex items-center bg-[#55ACEE] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} /> tweet
              </a>
            </div>
            <div className="flex items-center bg-[#34AF23] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} /> whatsapp
              </a>
            </div>
            <div className="flex items-center bg-[#0798CF] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} /> linkedin
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RevolutionizeMobileConnectivity;